<div class="rfq-pricing row">
  <div class="col-md-12">
    <div>
      <mat-select
        placeholder="Quantity Pricing Schedule"
        class="lum-select w-55"
        [value]="selectedPricingSchedule"
        (selectionChange)="onSelectPricingSchedule($event)"
      >
        <mat-option
          *ngFor="let schedule of pricingSchedules$ | async; trackBy: trackById"
          [value]="schedule"
          >{{ schedule?.name }}</mat-option
        >
      </mat-select>
    </div>
    <button
      *ngIf="selectedPricingSchedule && rfq.price_schedule_id"
      class="btn btn-primary button-space"
      type="button"
      (click)="detachPricingSchedule()"
    >
      Detach Pricing Schedule
    </button>

    <cnc-rfq-pricing-table
      [pricingSchedule]="selectedPricingSchedule"
      [rfq]="rfq"
      [pricingLevels]="pricingLevels$ | async"
      [pricingOverrides]="pricingOverrides$ | async"
      (tierOverride)="tierOverride($event)"
    ></cnc-rfq-pricing-table>

    <div *ngIf="selectedPricingSchedule" class="text-right">
      <button
        (click)="submit()"
        [disabled]="selectedPricingSchedule?.id === rfq?.price_schedule_id"
        class="btn btn-primary btn-sm"
      >
        <span *ngIf="(submittingForm$ | async) === false; else loader">Save</span>
      </button>
      <ng-template #loader>
        <mat-spinner diameter="18"></mat-spinner>
      </ng-template>
    </div>

    <div class="client-price-overrides mt-5">
      <cnc-client-price-overrides [rfqId]="rfq.id"></cnc-client-price-overrides>
    </div>
  </div>
</div>
